const mutations = {
    COMMIT_TELCOS: (state, payload) => {
        state.telcos = payload
    },

    COMMIT_DATA_CATEGORIES: (state, payload) => {
        state.data_categories = payload
    },

    COMMIT_DATA_SERVICES: (state, payload) => {
        state.data_services[payload.id] = payload.data
    },
}

export default mutations
